import { Http } from "@/util";

const BASE = "/admin/vehicleMonitor";

function query(extra) {
  return { deviceType: "zhijia", _hideLoading: true, ...extra };
}

export function zhijiaOnline(deviceKey) {
  return Http.get(`${BASE}/online`, query({ deviceKey }));
}

export function zhijiaLive(deviceKey, channel) {
  return Http.get(`${BASE}/live`, query({ deviceKey, channel }));
}

export function zhijiaCapture(deviceKey, channel) {
  return Http.get(`${BASE}/capture`, query({ deviceKey, channel }));
}

export function zhijiaCaptures(deviceKey, channel, startTime, endTime) {
  return Http.get(`${BASE}/captures`, query({ deviceKey, channel, startTime, endTime }));
}

export function zhijiaRecords(deviceKey, channel, startTime, endTime) {
  return Http.get(`${BASE}/records`, query({ deviceKey, channel, startTime, endTime }));
}

export function zhijiaDownloadStart(deviceKey, channel, startTime, endTime) {
  return Http.get(`${BASE}/download/start`, query({ deviceKey, channel, startTime, endTime, storageType: 0 }));
}

export function zhijiaDownloadProgress(deviceKey, channel, streamId, startTime, endTime) {
  return Http.get(`${BASE}/download/progress`, query({ deviceKey, channel, streamId, startTime, endTime }));
}

export function zhijiaDownloadFile(deviceKey, channel, streamId, fileName, startTime, endTime) {
  return Http.get(`${BASE}/download/file`, query({ deviceKey, channel, streamId, fileName, startTime, endTime }));
}

function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export async function downloadZhijiaClip(deviceKey, channel, startTime, endTime) {
  const startRes = await zhijiaDownloadStart(deviceKey, channel, startTime, endTime);
  const ticket = startRes.data || {};
  for (let i = 0; i < 30; i++) {
    await sleep(2000);
    const progressRes = await zhijiaDownloadProgress(deviceKey, channel, ticket.streamId, startTime, endTime);
    const progress = (progressRes.data && progressRes.data.progress) || 0;
    if (progress >= 100) {
      const fileRes = await zhijiaDownloadFile(deviceKey, channel, ticket.streamId, ticket.fileName, startTime, endTime);
      return (fileRes.data && fileRes.data.url) || "";
    }
  }
  return "";
}
